import { createStore, applyMiddleware, combineReducers } from "redux";
import createSagaMiddleware from "redux-saga";
import type { Store } from "redux";
import timeReducer from "./time/reducers/time";
import type { TimeAction } from "./time/types";
import logSaga from "./log/sagas/log";
import logReducer from "./log/reducers/log";
import type { LogAction } from "./log/types";
import loginSaga from "./user/sagas/login";
import signupSaga from "./user/sagas/signup";
import userReducer from "./user/reducers/user";
import type { UserActions } from "./user/types";
import habitsSaga from "./habits/sagas/habits";
import habitsReducer from "./habits/reducers/habits";
import availableHabitsReducer from "./habits/reducers/availableHabits";
import type { HabitActions } from "./habits/types";
const appReducer = combineReducers({
  log: logReducer,
  time: timeReducer,
  user: userReducer,
  habits: habitsReducer,
  availableHabits: availableHabitsReducer,
});
export type State = ReturnType<typeof appReducer>;

const rootReducer: (arg0: State | void, arg1: Actions) => State = (
  state: State,
  action: Actions
) => {
  if (action.type === "LOGOUT_SUCCESS") {
    state = undefined;
  }

  return appReducer(state, action);
};

const sagaMiddleware = createSagaMiddleware();
type Actions = LogAction<any> | TimeAction | UserActions | HabitActions;
const store: Store<void | State, Actions> = createStore(
  rootReducer,
  applyMiddleware(sagaMiddleware)
);
sagaMiddleware.run(logSaga);
sagaMiddleware.run(loginSaga);
sagaMiddleware.run(signupSaga);
sagaMiddleware.run(habitsSaga);
export default store;
